import { render, staticRenderFns } from "./businessTableHisList.vue?vue&type=template&id=10f70e28&scoped=true"
import script from "./businessTableHisList.vue?vue&type=script&lang=js"
export * from "./businessTableHisList.vue?vue&type=script&lang=js"
import style0 from "./businessTableHisList.vue?vue&type=style&index=0&id=10f70e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f70e28",
  null
  
)

export default component.exports